import React from "react";
import { Box, Typography } from "@material-ui/core";
import {
  CustomBadge,
  CustomButton,
  UnitsModelsCradSkeleton,
} from "../../../../../../../../Components";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { UnitsModelsCrad } from "../";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

function UnitsModelsComponent({
  setTabValue,
  unitModels,
  isLoadingUnitModels,
}) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();

  return (
    <Box className={styles.wrapperUnitsModelsComponent}>
      <Box className={styles.containerHeader}>
        {isLoadingUnitModels ? (
          <>
            <Box className={styles.containerLeftSide}>
              <Skeleton variant="text" width={98} height={45} />
              <Skeleton
                style={{ borderRadius: "16px" }}
                width="39px"
                height="45px"
                variant="text"
              />
            </Box>
            <Skeleton variant="text" width={53} height={45} />
          </>
        ) : (
          <>
            <Box className={styles.containerLeftSide}>
              <Typography className={styles.containerMainTitle}>
                {translate("Units-Models")}
              </Typography>
              <CustomBadge
                label={`${unitModels?.totalCount} Units models`}
                SizeVariant={"large"}
                BackgroundColor={palette.utility["brand_50"]}
                BorderColor={palette.utility["brand_200"]}
                Color={palette.utility["brand_700"]}
              />
            </Box>
            {unitModels?.result?.length > 0 && (
              <CustomButton
                boxShadow="none"
                size="sm"
                variant="text"
                color="tertiaryGray"
                style={{ minWidth: "fit-content" }}
                onClick={() => {
                  setTabValue(1);
                }}
              >
                {translate("View-All")}
              </CustomButton>
            )}
          </>
        )}
      </Box>
      <Box className={styles.containerCards}>
        {isLoadingUnitModels ? (
          <>
            {[...Array(3)].map((_, index) => (
              <UnitsModelsCradSkeleton key={index} />
            ))}
          </>
        ) : (
          <>
            {unitModels &&
              unitModels?.result.length > 0 &&
              unitModels?.result
                ?.slice(0, 3)
                ?.map((itemCard, index) => (
                  <UnitsModelsCrad unitsModel={itemCard} />
                ))}
          </>
        )}
      </Box>
    </Box>
  );
}
export default UnitsModelsComponent;
